/**
 * @module actions/users
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Create base user
 * @return {Promise} Axios promise
 */
export function createBaseUser (data) {
  let url = API_URL + '/Users/Create'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/users.js